module.exports = "<!-- <app-ultilities-menu></app-ultilities-menu> -->\r\n<div class=\"clearfix\"></div>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/ultilities.component.html
// module id = ./src/app/ultilities/ultilities.component.html
// module chunks = main